var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g, _path73, _path74, _g2, _path75, _path76, _g3, _path77, _path78, _g4, _path79, _path80, _g5, _path81, _path82, _path83, _path84, _path85, _path86, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroFintech2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 530,
    viewBox: "0 0 800 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_407)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M770 0H30C13.4315 0 0 13.4315 0 30V500C0 516.569 13.4315 530 30 530H770C786.569 530 800 516.569 800 500V30C800 13.4315 786.569 0 770 0Z",
    fill: "#F9FDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400.427 609.942C590.697 609.942 744.942 455.697 744.942 265.427C744.942 75.157 590.697 -79.087 400.427 -79.087C210.157 -79.087 55.913 75.157 55.913 265.427C55.913 455.697 210.157 609.942 400.427 609.942ZM400.427 671.854C624.891 671.854 806.854 489.891 806.854 265.427C806.854 40.964 624.891 -141 400.427 -141C175.964 -141 -6 40.964 -6 265.427C-6 489.891 175.964 671.854 400.427 671.854Z",
    fill: "#EFFAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.762 228.895L280.742 60.029L519.64 60L519.66 228.866L280.762 228.895Z",
    fill: "#8EB2DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M283.88 63.16L516.502 63.13L516.522 225.735L283.9 225.764L283.88 63.16Z",
    fill: "#D7E6FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M425.388 194.428L343.792 194.436C343.017 194.437 342.274 194.13 341.725 193.582C341.176 193.035 340.867 192.292 340.866 191.517C340.867 191.133 340.943 190.753 341.09 190.399C341.238 190.045 341.453 189.723 341.725 189.452C341.997 189.181 342.319 188.966 342.674 188.82C343.028 188.673 343.408 188.598 343.792 188.599L425.386 188.59C425.77 188.589 426.15 188.664 426.504 188.811C426.859 188.957 427.181 189.172 427.452 189.443C427.724 189.714 427.94 190.035 428.087 190.39C428.234 190.744 428.31 191.123 428.31 191.507C428.309 192.282 428.001 193.024 427.453 193.572C426.905 194.119 426.163 194.427 425.388 194.428ZM425.39 211.584L343.794 211.593C343.41 211.593 343.03 211.518 342.676 211.372C342.321 211.225 341.999 211.01 341.727 210.739C341.456 210.468 341.24 210.146 341.093 209.792C340.946 209.438 340.87 209.058 340.869 208.674C340.869 208.29 340.945 207.91 341.093 207.556C341.24 207.201 341.455 206.879 341.727 206.608C341.999 206.337 342.321 206.122 342.676 205.976C343.03 205.83 343.41 205.754 343.794 205.755L425.387 205.746C425.771 205.745 426.151 205.82 426.506 205.967C426.861 206.113 427.183 206.328 427.455 206.599C427.727 206.87 427.943 207.192 428.09 207.547C428.237 207.901 428.313 208.281 428.313 208.665C428.312 209.439 428.004 210.182 427.456 210.729C426.908 211.277 426.165 211.584 425.39 211.584ZM489.89 178.472L301.032 178.496V176.987L489.89 176.965V178.472Z",
    fill: "#8EB2DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M487.777 180.798V174.639L496.243 177.718L487.777 180.798ZM309.828 87.676L309.841 187.861H311.422L311.41 87.676H309.828Z",
    fill: "#8EB2DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307.392 90.535H313.847L310.62 82.869L307.392 90.535Z",
    fill: "#8EB2DD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M329.798 197.517H329.311C327.905 197.518 326.556 196.961 325.561 195.969C324.566 194.976 324.005 193.629 324.003 192.223C324.003 189.3 326.38 186.93 329.31 186.93H329.798C330.494 186.929 331.183 187.065 331.826 187.331C332.47 187.596 333.054 187.986 333.547 188.477C334.04 188.969 334.431 189.553 334.698 190.195C334.965 190.838 335.102 191.527 335.103 192.223C335.102 192.919 334.965 193.608 334.698 194.251C334.431 194.893 334.04 195.477 333.547 195.969C333.054 196.46 332.47 196.85 331.826 197.116C331.183 197.381 330.494 197.518 329.798 197.517Z",
    fill: "#2A4E96"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M329.8 212.722H329.314C328.618 212.723 327.928 212.587 327.284 212.322C326.641 212.056 326.056 211.667 325.563 211.175C325.07 210.683 324.679 210.099 324.411 209.456C324.144 208.813 324.007 208.124 324.006 207.428C324.008 206.023 324.568 204.676 325.562 203.683C326.557 202.691 327.906 202.134 329.311 202.135H329.8C332.729 202.135 335.106 204.503 335.106 207.426C335.105 208.122 334.968 208.811 334.701 209.454C334.434 210.097 334.043 210.681 333.55 211.173C333.057 211.665 332.472 212.055 331.829 212.321C331.186 212.586 330.496 212.723 329.8 212.722Z",
    fill: "#F99746"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M479.837 92.25L468.99 93.152L470.415 95.958L436.371 111.952L404.569 165.288L367.034 133.183L336.755 147.835L336.668 147.875L317.366 165.813L318.247 166.679L337.412 148.866L366.835 134.632L404.891 167.182L437.277 112.868L470.967 97.043L472.375 99.811L479.837 92.25Z",
    fill: "#699FF0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M336.978 152.688H336.616C335.576 152.689 334.578 152.276 333.842 151.542C333.106 150.808 332.691 149.811 332.689 148.771C332.689 148.256 332.791 147.746 332.989 147.271C333.187 146.796 333.476 146.364 333.84 146C334.205 145.636 334.637 145.348 335.113 145.152C335.589 144.955 336.099 144.854 336.614 144.855H336.975C337.49 144.854 338 144.955 338.476 145.152C338.952 145.348 339.384 145.636 339.749 146C340.113 146.364 340.402 146.796 340.6 147.271C340.797 147.746 340.899 148.256 340.9 148.771C340.899 149.811 340.486 150.807 339.75 151.542C339.015 152.276 338.017 152.689 336.978 152.688ZM436.827 117.127H436.466C435.951 117.128 435.441 117.027 434.965 116.83C434.489 116.634 434.057 116.346 433.692 115.982C433.328 115.618 433.039 115.187 432.841 114.711C432.643 114.236 432.541 113.726 432.541 113.211C432.541 112.696 432.643 112.187 432.84 111.711C433.037 111.236 433.326 110.804 433.69 110.44C434.055 110.077 434.487 109.788 434.963 109.592C435.438 109.395 435.948 109.294 436.463 109.295H436.824C437.339 109.294 437.849 109.395 438.325 109.592C438.801 109.788 439.233 110.076 439.598 110.44C439.962 110.804 440.251 111.236 440.449 111.711C440.646 112.186 440.748 112.696 440.749 113.211C440.749 113.726 440.647 114.235 440.45 114.711C440.253 115.186 439.964 115.618 439.6 115.982C439.235 116.346 438.803 116.634 438.327 116.83C437.851 117.027 437.342 117.128 436.827 117.127ZM366.933 138.822H366.572C366.057 138.823 365.547 138.722 365.071 138.526C364.596 138.329 364.163 138.041 363.799 137.677C363.434 137.314 363.145 136.882 362.947 136.407C362.75 135.931 362.648 135.422 362.647 134.907C362.648 133.867 363.063 132.87 363.799 132.136C364.535 131.401 365.532 130.989 366.572 130.99H366.933C367.972 130.989 368.97 131.4 369.706 132.134C370.442 132.868 370.856 133.865 370.858 134.904C370.858 135.419 370.756 135.929 370.559 136.405C370.361 136.88 370.072 137.313 369.707 137.676C369.343 138.04 368.91 138.329 368.434 138.525C367.958 138.722 367.448 138.823 366.933 138.822Z",
    fill: "#2A4E96"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M404.73 169.046H404.369C403.854 169.047 403.344 168.946 402.868 168.749C402.392 168.553 401.959 168.264 401.595 167.901C401.23 167.537 400.941 167.105 400.744 166.629C400.546 166.154 400.444 165.644 400.444 165.129C400.444 164.614 400.546 164.104 400.744 163.629C400.941 163.154 401.231 162.722 401.595 162.358C401.96 161.994 402.392 161.706 402.868 161.51C403.344 161.313 403.854 161.212 404.369 161.213H404.73C405.245 161.212 405.755 161.313 406.23 161.509C406.706 161.705 407.139 161.993 407.503 162.357C407.868 162.72 408.157 163.152 408.355 163.627C408.552 164.103 408.654 164.612 408.655 165.127C408.654 166.167 408.24 167.164 407.504 167.899C406.768 168.634 405.77 169.047 404.73 169.046Z",
    fill: "#F99746"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.757 471.482H730.817C731.233 471.482 731.574 471.142 731.574 470.726V470.454C731.573 470.253 731.494 470.061 731.352 469.919C731.21 469.777 731.018 469.698 730.817 469.697H69.757C69.5565 469.698 69.3644 469.778 69.2226 469.92C69.0808 470.061 69.0008 470.254 69 470.454V470.729C69 471.142 69.34 471.482 69.757 471.482Z",
    fill: "#2E3552"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M359.572 413.512C359.572 413.512 350.352 402.782 359.005 395.964C359.005 395.964 365.324 392.147 370.475 392.458C370.475 392.458 363.175 404.671 365.537 405.888C367.899 407.103 372.687 391.691 372.687 391.691C372.687 391.691 387.069 390.299 391.693 392.518C391.693 392.518 379.4 402.555 381.99 403.153C384.579 403.75 397.857 393.897 397.857 393.897C397.857 393.897 411.241 396.172 410.527 404.318C409.813 412.463 405.201 414.979 403.175 414.763C401.148 414.545 389.293 410.03 389.033 411.687C388.775 413.345 395.912 418.759 400.91 419.012C400.91 419.012 391.474 429.396 385.204 426.399C378.932 423.402 378.397 418.652 374.487 416.872C370.578 415.089 367.243 415.094 368.856 416.912C370.47 418.728 377.545 420.492 379.78 424.44C382.014 428.385 384.021 431.046 377.534 430.071C371.045 429.097 360.498 424.361 360.037 418.936L359.572 413.512Z",
    fill: "#429600"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M403.95 404.538C403.95 404.538 367.601 403.14 359.572 413.513C359.572 413.513 357.796 418.818 352.334 423.649L351.482 425.966C351.482 425.966 357.781 419.339 360.036 418.937C360.036 418.937 356.51 406.086 403.95 404.538Z",
    fill: "#82B378"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M352.334 423.649C352.334 423.649 344.531 429.405 343.989 439.693L345.405 439.818C345.405 439.818 347.898 429.184 352.401 425.024C356.907 420.864 352.334 423.649 352.334 423.649Z",
    fill: "#82B378"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M327.339 400.018C327.339 400.018 342.005 391.823 335.16 380.7C335.16 380.7 329.685 373.872 323.82 372.117C323.82 372.117 326.947 388.7 323.82 389.089C320.69 389.481 321.668 370.361 321.668 370.361C321.668 370.361 306.219 362.947 300.158 363.531C300.158 363.531 309.74 379.725 306.612 379.334C303.482 378.944 292.727 362.556 292.727 362.556C292.727 362.556 276.889 359.63 274.347 368.994C271.804 378.359 275.911 383.042 278.257 383.628C280.603 384.212 295.661 384.017 295.269 385.969C294.879 387.92 284.709 391.042 279.041 389.287C279.041 389.287 285.296 404.699 293.509 403.917C301.722 403.137 304.264 398.065 309.348 397.675C314.432 397.284 318.149 398.65 315.607 400.018C313.065 401.381 304.459 400.465 300.353 403.947C296.246 407.431 292.923 409.576 300.55 411.137C308.175 412.698 321.863 411.723 324.602 405.87L327.339 400.018Z",
    fill: "#51B800"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M281.583 371.924C281.583 371.924 322.645 385.191 327.339 400.019C327.339 400.019 327.143 406.653 331.247 414.261V417.186C331.247 417.186 326.946 407.236 324.601 405.872C324.601 405.872 333.792 392.994 281.583 371.924Z",
    fill: "#82B378"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M331.247 414.261C331.247 414.261 337.582 423.856 333.971 435.535L332.342 435.099C332.342 435.099 333.924 422.234 330.611 415.764C327.298 409.294 331.247 414.261 331.247 414.261Z",
    fill: "#82B378"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M350.671 388.716C350.671 388.716 331.338 377.914 340.36 363.253C340.36 363.253 347.577 354.251 355.311 351.937C355.311 351.937 351.187 373.799 355.311 374.313C359.433 374.827 358.146 349.624 358.146 349.624C358.146 349.624 378.509 339.851 386.499 340.622C386.499 340.622 373.868 361.967 377.993 361.453C382.117 360.939 396.293 339.336 396.293 339.336C396.293 339.336 417.172 335.478 420.523 347.824C423.874 360.167 418.461 366.34 415.368 367.111C412.274 367.883 392.428 367.626 392.944 370.198C393.46 372.77 406.861 376.886 414.337 374.57C414.337 374.57 406.088 394.887 395.264 393.858C384.437 392.829 381.086 386.144 374.384 385.63C367.682 385.115 362.784 386.916 366.135 388.716C369.487 390.514 380.828 389.304 386.242 393.896C391.655 398.488 396.037 401.317 385.984 403.374C375.931 405.432 357.888 404.146 354.279 396.43L350.671 388.716Z",
    fill: "#51B800"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M410.986 351.682C410.986 351.682 356.857 369.169 350.671 388.716C350.671 388.716 350.929 397.459 345.516 407.49V411.348C345.516 411.348 351.187 398.23 354.279 396.43C354.279 396.43 342.165 379.457 410.986 351.682Z",
    fill: "#82B378"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M345.515 407.489C345.515 407.489 337.167 420.136 341.926 435.532L344.074 434.958C344.074 434.958 341.989 418.001 346.356 409.47C350.724 400.942 345.515 407.489 345.515 407.489Z",
    fill: "#82B378"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M350.019 468.923C370.932 468.923 387.887 452.006 387.887 431.139H312.15C312.15 452.006 329.105 468.923 350.019 468.923Z",
    fill: "#F99746"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M338.835 468.633C340.376 468.825 341.946 468.924 343.541 468.924C364.454 468.924 381.407 452.006 381.407 431.137H371.999C371.999 450.416 357.529 466.322 338.835 468.633Z",
    fill: "#FFAC6E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M388.41 470.844H311.628C311.628 470.231 311.75 469.625 311.985 469.059C312.22 468.493 312.565 467.979 312.998 467.546C313.432 467.113 313.947 466.77 314.514 466.537C315.08 466.303 315.687 466.183 316.3 466.184H383.738C384.351 466.183 384.958 466.303 385.524 466.537C386.09 466.77 386.605 467.113 387.039 467.546C387.473 467.979 387.817 468.493 388.053 469.059C388.288 469.625 388.409 470.231 388.41 470.844ZM388.748 432.298H310.905V431.137H388.748V432.298Z",
    fill: "#ED7D2B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M185.564 164.281C185.564 164.281 195.427 175.959 207.989 171.074C207.989 171.074 210.691 164.553 210.729 159.747C210.733 159.154 210.74 158.58 210.751 158.035C210.817 152.623 211 149.585 211 149.585L210.988 149.582C210.416 149.345 191.785 141.714 191.801 142.348C192.12 156.987 185.564 164.281 185.564 164.281Z",
    fill: "#FFB27D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M193.671 145.838C195.468 149.161 201.633 155.663 210.751 158.036C210.817 152.624 211 149.586 211 149.586L210.988 149.583C210.472 149.445 193.136 144.86 193.671 145.838Z",
    fill: "#ED975D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M214.903 149.023C214.903 149.023 193.95 153.937 191.083 140.871C188.217 127.807 183.581 119.641 196.838 115.951C210.095 112.26 213.797 116.676 215.817 120.804C217.836 124.933 220.279 147.407 214.903 149.023Z",
    fill: "#FFB27D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M191.8 144.432C191.514 144.615 187.006 145.997 178.468 129.026C177.128 126.364 176.214 120.6 179.339 115.509C182.463 110.415 193.541 106.412 202.745 104.669C211.948 102.927 214.158 108.094 216.326 113.287C218.601 118.74 225.171 123.228 225.171 123.228C217.234 127.652 207.675 121.325 204.364 122.365C201.052 123.406 199.882 128.615 199.633 130.283C199.385 131.953 199.003 133.338 194.839 131.848C190.674 130.357 192.956 137.735 193.623 139.149C193.623 139.149 194.189 142.907 191.8 144.432Z",
    fill: "#A9453D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.827 470.271H125.14C122.48 470.271 119.525 467.612 118.785 462.749C118.045 457.882 112.579 455.227 111.394 451.247C110.212 447.264 116.274 441.657 116.274 441.657L117.287 440.358L118.341 439.004L128.391 441.362C128.391 441.362 128.639 443.751 128.794 446.793C128.901 448.988 128.961 451.526 128.835 453.751C128.539 459.063 130.326 464.78 135.052 465.813C139.784 466.845 137.827 470.271 137.827 470.271ZM226.147 470.271H192.518C192.195 470.208 191.951 470.138 191.803 470.064C189.558 468.943 190.261 460.365 190.531 457.715C190.583 457.225 190.619 456.938 190.619 456.938C190.619 456.938 202.444 447.499 204.072 454.726C204.124 454.95 204.183 455.173 204.247 455.392V455.394C206.299 462.157 215.475 465.227 220.777 466.082C224.826 466.739 225.877 469.094 226.147 470.271Z",
    fill: "#2C3A64"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M219.369 276.773C219.369 276.773 217.573 299.129 215.462 326.003C212.593 362.509 209.143 407.352 208.802 415.847C208.212 430.599 205.844 454.194 205.844 454.194C205.844 454.194 200.23 459.798 188.993 457.436C188.993 457.436 178.98 423.753 176.12 388.115L175.988 386.352C173.327 350.074 169.189 273.674 169.189 273.674L219.369 276.773Z",
    fill: "#2B478B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M219.369 276.773C219.369 276.773 217.573 299.129 215.462 326.003L176.12 388.115L175.988 386.352C173.327 350.074 169.189 273.674 169.189 273.674L219.369 276.773Z",
    fill: "#233862"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M211.167 279.428C211.167 279.428 178.797 360.393 157.511 398.445C136.226 436.495 129.575 447.115 129.575 447.115C129.575 447.115 117.38 442.248 116.271 438.928C116.271 438.928 124.411 365.471 138.665 347.564C146.72 337.444 156.181 307.078 156.624 296.461C157.068 285.843 159.507 264.824 159.507 264.824L211.167 279.428Z",
    fill: "#2B478B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 264.717L137.002 269.925C137.002 269.925 140.444 279.176 130.8 283.92C130.8 283.92 126.672 285.581 126.504 282.376C126.337 279.168 126.865 280.375 126.53 275.858C126.194 271.344 127.974 267.077 130.967 265.64L133.423 262.812L137.344 264.717Z",
    fill: "#FFB27D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M133.578 268.507C137.16 269.656 137.735 269.395 137.735 269.395C137.735 269.395 155.174 237.717 156.941 234.816C158.706 231.916 193.968 199.291 193.968 199.291L184.906 165.576C184.906 165.576 144.801 217.394 140.471 224.83C133.314 237.117 129.121 265.652 129.121 265.652C129.121 265.652 130.764 267.605 133.578 268.507Z",
    fill: "#21AAE9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M160.547 278.706C169.41 283.931 177.773 287.806 187.486 289.851C198.996 292.352 213.056 291.283 217.77 291.875C218.275 291.932 218.739 291.797 219.148 291.523C219.494 291.307 221.346 277.139 223.114 259.211C223.161 258.799 223.209 258.363 223.243 257.93C223.266 257.641 223.283 257.351 223.29 257.07L223.32 256.817C223.513 254.954 223.7 253.056 223.873 251.137C224.347 245.808 224.766 240.475 225.129 235.138C225.674 227.236 226.077 219.45 226.203 212.529C226.206 212.362 226.209 212.195 226.209 212.031C226.304 206.233 226.206 201.05 225.836 196.935C225.768 196.116 225.679 195.3 225.569 194.486C224.194 184.092 219.152 176.78 214.418 171.289L209.789 166.048C205.345 166.436 201.499 166.595 197.16 163.818C192.46 160.81 189.425 157.98 188.473 158.51C181.199 162.758 173.321 173.202 169.372 187.379C167.249 195.013 165.668 203.604 164.679 212.649C164.298 216.168 164.008 219.697 163.811 223.232C162.782 242.43 159.769 258.833 158.021 268.368C157.52 271.112 157.123 273.292 156.907 274.802C156.69 276.175 159.373 278.012 160.547 278.706Z",
    fill: "#21AAE9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M193.968 188.975C193.968 188.975 197.925 232.639 223.243 257.932C223.266 257.643 223.284 257.354 223.29 257.072L223.32 256.819C223.513 254.956 223.7 253.058 223.873 251.139C224.305 246.278 224.691 241.414 225.031 236.546C225.064 236.079 225.098 235.61 225.129 235.14C225.674 227.238 226.077 219.453 226.203 212.531C226.206 212.364 226.209 212.197 226.209 212.033C226.158 207.894 226.036 204.12 225.836 200.805C217.73 194.348 207.208 189.838 193.968 188.975Z",
    fill: "#2096CC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M278.367 276.242L325.469 138.103C325.687 137.475 325.974 136.875 325.35 136.646L324.777 136.44C324.134 136.204 323.946 136.619 323.713 137.261L273.503 273.412C273.275 274.039 273.293 274.73 273.554 275.345C273.816 275.959 274.301 276.451 274.911 276.722L276.074 277.237C276.289 277.332 276.521 277.382 276.756 277.383C276.991 277.384 277.223 277.336 277.439 277.243C277.655 277.149 277.848 277.012 278.008 276.84C278.168 276.667 278.29 276.464 278.367 276.242Z",
    fill: "#2A4E96"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M291.019 216.882C291.043 214.861 296.388 210.187 296.743 210.75C296.997 211.154 296.445 213.278 296.147 214.172C298.367 212.691 298.873 207.448 302.622 205.112C303.662 204.462 307.361 214.592 303.853 218.267C300.346 221.941 298.662 221.535 292.819 224.935L288.588 225.218L286.499 218.656C286.499 218.656 288.756 217.831 291.019 216.882Z",
    fill: "#FFB27D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M293.206 222.188C293.484 218.205 288.219 215.9 288.219 215.9C288.219 215.9 248.114 220.072 244.664 218.991C241.213 217.906 215.438 181.001 215.438 181.001C215.438 181.001 204.13 168.276 194.872 171.087C186.826 173.529 183.681 179.791 182.61 185.756C181.335 192.865 184.619 200.017 190.789 203.793C204.639 212.27 228.863 235.63 235.392 237.54C249.926 241.79 291.437 227.895 291.437 227.895C291.437 227.895 292.99 225.318 293.206 222.188Z",
    fill: "#21AAE9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M635.208 337.628C635.98 318.626 637.65 302.098 639.648 290.57C642.832 272.194 645.7 261.624 645.733 261.513C646.153 259.897 652.212 253.36 665.688 253.559C679.162 253.762 677.883 262.336 677.883 262.336C677.888 262.594 677.856 262.85 677.789 263.099C677.659 263.54 665.289 308.288 665.825 366.063C665.832 366.877 665.925 368.279 665.866 369.214C665.866 369.216 634.641 370.017 634.632 369.214C633.544 364.162 634.075 350.17 635.208 337.628Z",
    fill: "#B7D3F3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M631.279 365.781C631.29 366.585 631.715 367.231 632.235 367.231H632.249C632.766 367.217 633.179 366.573 633.188 365.781H659.948C659.957 366.585 660.382 367.231 660.901 367.231H660.915C661.444 367.217 661.863 366.552 661.857 365.736C661.702 349.2 662.646 333.755 664.077 320.126C667.633 286.132 674.211 263.415 674.305 263.099C674.364 262.896 674.4 262.628 674.4 262.337C674.4 262.337 675.677 253.762 662.204 253.559C648.728 253.357 642.669 259.897 642.249 261.514C642.224 261.599 640.601 267.585 638.442 278.347C637.628 282.411 636.868 286.486 636.164 290.57C634.166 302.098 632.496 318.626 631.721 337.625C630.59 350.17 630.193 360.733 631.279 365.781Z",
    fill: "#D2E3FC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M663.836 367.229H558.917C558.917 367.229 561.363 357.365 622.121 358.835C665.122 359.874 663.836 367.229 663.836 367.229Z",
    fill: "#C5DCF8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M672.374 470.271C660.21 408.826 663.338 371.123 663.352 370.649C663.382 369.701 661.635 368.844 660.696 368.814C659.743 368.797 655.545 368.533 655.061 369.343C654.421 370.402 651.974 416.859 670.104 470.271H672.374ZM574.417 470.271C586.58 408.826 583.452 371.123 583.436 370.649C583.404 369.701 585.153 368.844 586.094 368.814C587.045 368.797 591.243 368.533 591.729 369.343C592.365 370.402 594.816 416.859 576.686 470.271H574.417ZM555.002 470.271C567.167 408.826 564.038 371.123 564.024 370.649C563.994 369.701 565.741 368.844 566.681 368.814C567.631 368.797 571.832 368.533 572.315 369.343C572.952 370.402 575.403 416.859 557.273 470.271H555.002ZM652.83 470.271C640.665 408.826 643.793 371.123 643.807 370.649C643.838 369.701 642.09 368.844 641.151 368.814C640.201 368.797 636.002 368.533 635.516 369.343C634.88 370.402 632.429 416.859 650.559 470.271H652.83Z",
    fill: "#B7D3F3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M558.856 370.381H663.772C664.955 370.381 665.922 369.416 665.922 368.236V366.827C665.922 365.647 664.955 364.682 663.772 364.682H558.856C557.676 364.682 556.708 365.647 556.708 366.827V368.236C556.708 369.416 557.676 370.381 558.856 370.381Z",
    fill: "#B7D3F3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M562.543 275.844L527.667 268.307L525.614 273.302C525.614 273.302 564.093 296.149 567.7 295.029C571.305 293.912 562.543 275.844 562.543 275.844ZM594.25 433.215C595.122 434.213 595.233 435.33 594.8 436.523C594.8 436.528 594.797 436.534 594.791 436.539C593.995 438.743 591.352 441.205 588.284 443.661C587.893 443.978 587.545 444.266 587.239 444.532C587.159 444.601 587.081 444.671 587.006 444.74L586.826 444.904C583.964 447.534 585.041 448.138 579.901 453.478C574.041 459.56 570.007 459.672 568.86 459.117C567.887 458.643 569.859 455.416 572.046 451.79C572.152 451.615 572.255 451.438 572.366 451.261C572.655 450.781 572.944 450.29 573.233 449.805C575.797 445.441 575.138 443.393 574.531 436.896C574.039 431.618 566.3 407.408 566.3 407.408L577.532 405.475C577.532 405.475 580.913 424.756 584.639 427.726C586.631 429.306 588.862 429.329 590.776 430.502C590.913 430.582 591.046 430.665 591.177 430.751C592.263 431.472 593.372 432.215 594.25 433.215Z",
    fill: "#FFB27D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M594.249 433.216C595.122 434.213 595.233 435.331 594.8 436.523C594.8 436.529 594.796 436.534 594.791 436.539C593.813 438.741 591.241 441.188 588.273 443.639C587.887 443.961 587.545 444.255 587.239 444.533C587.101 444.657 586.963 444.781 586.825 444.904C583.963 447.535 585.041 448.139 579.901 453.479C574.041 459.561 570.007 459.672 568.859 459.118C567.887 458.643 569.859 455.416 572.046 451.791C573.188 451.375 578.487 449.226 582.494 444.111C586.022 439.617 588.375 433.845 590.776 430.502C590.913 430.582 591.045 430.665 591.177 430.751C592.263 431.472 593.371 432.215 594.249 433.216Z",
    fill: "#1C468A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M503.692 426.216C502.999 429.674 498.057 429.097 492.535 427.753C487.014 426.405 488.328 428.005 480.471 427.137C472.613 426.269 470.232 423.348 469.993 422.18C469.779 421.146 473.661 420.783 477.826 420.303C478.348 420.245 478.876 420.181 479.401 420.115C484.103 419.527 487.545 416.5 491.816 414.013C495.861 411.659 501.899 402.064 501.899 402.064L512.674 402.918C512.674 402.918 507.02 411.487 504.834 415.21C503.546 417.403 503.614 420.3 503.774 422.538C503.858 423.755 503.938 424.997 503.692 426.216Z",
    fill: "#FFB27D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M492.535 427.754C487.014 426.406 488.328 428.007 480.471 427.138C472.613 426.271 470.232 423.349 469.993 422.181C469.779 421.147 473.661 420.784 477.826 420.305L477.864 420.385C477.864 420.385 482.577 423.717 489.118 423.875C494.447 424.003 500.093 422.48 503.774 422.539C503.858 423.756 503.938 424.998 503.692 426.218C502.999 429.675 498.057 429.098 492.535 427.754Z",
    fill: "#1C468A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M527.668 268.304C527.668 268.304 525.1 262.028 522.277 261.772C519.452 261.517 510.468 260.106 509.826 261.388C509.185 262.668 509.826 267.281 511.75 268.944C513.675 270.611 525.614 273.3 525.614 273.3L527.668 268.304Z",
    fill: "#FFB27D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M544.986 357.468L568.209 419.827C568.209 419.827 571.777 420.174 575.197 419.189C578.346 418.283 581.952 415.907 581.952 415.907C581.952 415.907 576.189 356.032 565.628 343.579C555.067 331.123 544.986 357.468 544.986 357.468Z",
    fill: "#163560"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M636.84 332.244C636.84 332.244 570.11 309.73 555.227 314.52C540.346 319.311 495.661 408.012 495.661 408.012C495.661 408.012 496.669 409.351 499.423 410.38C501.982 411.339 508.182 411.277 508.182 411.277C508.182 411.277 548.507 376.79 553.307 366.732C558.109 356.671 560.029 347.092 564.827 348.05C569.629 349.008 626.759 371.52 639.72 358.11C652.683 344.698 649.293 327.27 649.293 327.27L636.84 332.244Z",
    fill: "#1C468A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M596.061 227.509C594.994 225.313 593.802 221.415 593.221 214.462C593.31 215.152 594.511 223.919 597.889 228.882C611.768 237.974 638.367 268.329 637.839 274.082C637.839 274.082 647.209 258.224 647.373 258.13C647.373 258.13 664.655 236.2 644.172 223.641C633.76 217.256 633.813 209.065 634.246 201.946C634.686 194.828 631.407 164.189 610.554 172.206C610.554 172.206 607.205 170.723 605.708 170.945C605.708 170.945 606.931 171.18 607.556 171.821C605.135 171.676 601.68 171.857 598.795 173.492C591.151 177.826 584.307 216.716 596.061 227.509Z",
    fill: "#2C3A64"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M598.711 229.337C598.642 229.369 605.411 232.875 610.504 231.486C615.295 230.183 618.423 223.984 618.359 223.97C616.328 223.568 615.744 220.787 615.787 208.836L614.869 209.017L599.451 212.063C599.451 212.063 599.801 216.904 599.812 221.464C599.823 225.296 599.59 228.927 598.711 229.337Z",
    fill: "#FFB27D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M599.451 212.062C599.451 212.062 599.801 216.903 599.812 221.463C608.44 221.222 613.003 213.368 614.869 209.016L599.451 212.062Z",
    fill: "#ED975D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M616.464 207.343C616.464 207.343 620.984 200.213 622.068 194.119C622.843 189.767 620.624 173.634 604.377 175.958C604.377 175.958 599.659 176.424 595.222 179.412C591.695 181.788 586.606 186.92 592.296 200.997L593.774 205.752L616.464 207.343Z",
    fill: "#2C3A64"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M596.57 216.381C596.57 216.381 616.984 216.717 616.998 204.028C617.012 191.342 619.657 182.839 606.623 182.087C593.589 181.337 591.052 186.174 590.016 190.41C588.976 194.644 591.26 215.965 596.57 216.381Z",
    fill: "#FFB27D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M597.326 181.778C597.326 181.778 602.913 196.662 611.493 198.864C620.071 201.064 623.791 198.772 623.791 198.772C623.791 198.772 620.651 191.115 619.287 182.011C619.287 182.011 601.541 174.691 597.326 181.778Z",
    fill: "#2C3A64"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M598.709 182.987C598.709 182.987 594.536 186.31 593.519 189.541C592.499 192.77 592.043 199.424 590.098 199.196C590.098 199.196 585.889 189.077 590.621 183.355C595.639 177.286 598.709 182.987 598.709 182.987Z",
    fill: "#2C3A64"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M644.172 284.136C646.183 275.71 639.335 259.365 632.185 245.831C625.697 233.565 618.962 223.613 618.359 223.97C601.246 234.103 599.701 225.681 599.701 225.681C599.693 225.681 584.158 227.741 579.757 235.298C574.299 244.677 568.4 270.881 562.544 275.843C563.441 278.589 563.055 280.052 562.102 283.457C561.908 284.16 561.681 284.854 561.424 285.536C560.54 287.931 559.437 289.875 558.484 291.563C561.463 293.368 567.212 296.8 571.449 294.333C577.906 290.56 582.946 279.079 585.784 274.507C585.794 274.489 585.803 274.471 585.814 274.455C591.98 309.27 583.597 317.199 587.839 320.872C592.321 324.748 598.723 319.026 612.805 325.116C622.04 329.115 634.861 334.894 643.488 335.901C648.014 336.431 651.39 335.644 652.494 332.594C655.691 323.734 640.329 300.196 644.172 284.136Z",
    fill: "#A8D29F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M601.106 208.688C601.106 208.688 600.725 210.302 596.708 210.053C596.708 210.053 593.332 209.845 593.438 208.073C593.438 208.073 596.708 206.811 601.106 208.688Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M652.494 332.591C651.39 335.64 648.014 336.427 643.488 335.898C637.517 333.3 611.715 323.328 612.004 316.568C612.433 306.563 616.964 306.245 613.767 293.897C611.196 283.98 635.033 265.544 638.836 261.535C645.986 275.07 646.183 275.707 644.172 284.132C640.329 300.192 655.691 323.73 652.494 332.591Z",
    fill: "#82B378"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M655.408 296.51C650.833 290.1 646.068 286.709 642.93 285.005C643.653 283.149 623.686 258.725 623.686 254.938C623.686 251.106 618.359 223.971 618.359 223.971C618.359 223.971 634.995 224.994 640.757 233.011C647.96 243.036 662.921 281.614 655.408 296.51Z",
    fill: "#A8D29F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M642.929 285.004L609.685 293.659L612.805 299.248C612.805 299.248 653.265 298.965 655.408 296.509C657.554 294.052 642.929 285.004 642.929 285.004Z",
    fill: "#FFB27D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M585.784 274.508C582.946 279.08 577.906 290.56 571.449 294.333C567.212 296.8 561.463 293.368 558.484 291.564C559.437 289.876 560.54 287.932 561.424 285.537C563.803 286.08 566.701 286.773 568.571 287.336C572.21 288.433 585.784 274.508 585.784 274.508Z",
    fill: "#82B378"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M609.685 293.658C609.685 293.658 599.243 290.712 596.756 291.402C594.27 292.089 585.75 297.719 586.948 299.247C588.146 300.778 595.65 298.332 599.107 298.796C602.561 299.258 605.231 300.957 607.717 300.589C610.205 300.223 612.805 299.247 612.805 299.247L609.685 293.658Z",
    fill: "#FFB27D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M609.684 293.658C609.684 293.658 604.574 291.041 603.121 289.549C602.941 289.361 602.629 289.402 602.487 289.622C602.098 290.234 601.735 291.418 603.527 292.594C606.106 294.287 609.684 293.658 609.684 293.658Z",
    fill: "#FFB27D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M561.435 308.313H610.146C610.145 307.803 610.044 307.299 609.849 306.829C609.653 306.358 609.367 305.931 609.006 305.571C608.645 305.211 608.217 304.926 607.746 304.731C607.275 304.537 606.771 304.437 606.261 304.438H561.435V308.313Z",
    fill: "#ED7D2B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M561.574 255.383H486.264L504.328 308.315H580.127L561.574 255.383Z",
    fill: "#ED7D2B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M485.152 255.383L503.221 308.312H579.017L560.465 255.383H485.152Z",
    fill: "#F99746"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_117_407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 537,
    y: 278,
    width: 2,
    height: 2
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M537.486 278.215H539V279.732H537.486V278.215Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 537,
    y: 278,
    width: 2,
    height: 2
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M538.423 278.29C538.345 278.272 538.266 278.266 538.187 278.271C538.107 278.277 538.03 278.295 537.956 278.324C537.882 278.353 537.815 278.392 537.754 278.441C537.693 278.491 537.643 278.548 537.601 278.612C537.59 278.637 537.575 278.659 537.563 278.681C537.543 278.719 537.529 278.759 537.52 278.801C537.508 278.846 537.501 278.891 537.498 278.937C537.496 278.983 537.498 279.029 537.506 279.075C537.513 279.121 537.524 279.165 537.541 279.209C537.558 279.252 537.578 279.294 537.604 279.333C537.628 279.373 537.658 279.41 537.69 279.444C537.723 279.479 537.759 279.51 537.798 279.538C537.838 279.565 537.879 279.589 537.924 279.609C537.968 279.628 538.014 279.644 538.061 279.655C538.138 279.673 538.215 279.679 538.293 279.673C538.372 279.668 538.447 279.651 538.52 279.624C538.593 279.596 538.659 279.559 538.72 279.511C538.781 279.464 538.832 279.409 538.874 279.347L538.929 279.243H538.932C538.947 279.21 538.959 279.177 538.967 279.142C538.978 279.097 538.985 279.052 538.987 279.005C538.99 278.96 538.987 278.914 538.979 278.868C538.972 278.822 538.96 278.778 538.943 278.735C538.926 278.692 538.906 278.65 538.881 278.611C538.855 278.571 538.826 278.534 538.793 278.5C538.76 278.466 538.724 278.435 538.685 278.408C538.646 278.38 538.604 278.357 538.56 278.337C538.516 278.317 538.47 278.302 538.423 278.29Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_117_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537.557 277.986L537.198 279.62L538.928 279.958L539.286 278.324L537.557 277.986Z",
    fill: "url(#paint0_linear_117_407)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 537,
    y: 285,
    width: 2,
    height: 2
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M537.339 285.384H538.956V286.9H537.339V285.384Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_117_407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 537,
    y: 285,
    width: 2,
    height: 2
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M538.371 285.467C538.293 285.449 538.214 285.443 538.134 285.449C538.054 285.454 537.977 285.471 537.904 285.501C537.83 285.53 537.762 285.569 537.702 285.618C537.641 285.668 537.59 285.725 537.549 285.789L537.509 285.858C537.491 285.896 537.476 285.937 537.465 285.978C537.443 286.059 537.437 286.141 537.446 286.225C537.456 286.309 537.48 286.388 537.52 286.463C537.559 286.539 537.611 286.605 537.676 286.663C537.741 286.721 537.814 286.766 537.896 286.799C537.978 286.832 538.063 286.851 538.152 286.854C538.241 286.859 538.328 286.848 538.413 286.823C538.498 286.797 538.575 286.759 538.646 286.708C538.716 286.656 538.775 286.595 538.822 286.524C538.842 286.491 538.86 286.455 538.877 286.423H538.88C538.894 286.39 538.903 286.357 538.915 286.322C538.926 286.277 538.933 286.231 538.936 286.185C538.938 286.139 538.936 286.093 538.928 286.047C538.921 286.001 538.909 285.957 538.892 285.913C538.876 285.87 538.855 285.828 538.829 285.789C538.804 285.749 538.775 285.712 538.742 285.678C538.709 285.643 538.673 285.613 538.634 285.585C538.594 285.558 538.553 285.534 538.508 285.514C538.464 285.494 538.418 285.478 538.371 285.467Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_117_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537.498 285.162L537.139 286.801L538.876 287.14L539.236 285.501L537.498 285.162Z",
    fill: "#2771E0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 524,
    y: 275,
    width: 13,
    height: 15
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M524 275H536.897V289.89H524V275Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_117_407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 524,
    y: 274,
    width: 13,
    height: 16
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M536.195 287.231C536.091 287.21 535.987 287.211 535.883 287.232C535.779 287.254 535.684 287.294 535.599 287.354C535.309 287.549 535.003 287.719 534.683 287.866C534.362 288.012 534.031 288.132 533.688 288.226C533.346 288.32 532.998 288.387 532.644 288.425C532.291 288.464 531.936 288.474 531.579 288.457L531.478 288.451C531.187 288.432 530.897 288.395 530.61 288.339C527.159 287.665 524.942 284.479 525.656 281.224C526.371 277.971 529.748 275.876 533.197 276.551C534.042 276.715 534.819 277.028 535.529 277.49H535.532C535.575 277.527 535.621 277.559 535.671 277.586C535.739 277.619 535.81 277.644 535.886 277.659C535.969 277.675 536.053 277.677 536.137 277.666C536.222 277.655 536.302 277.631 536.378 277.595C536.454 277.559 536.521 277.511 536.58 277.453C536.639 277.395 536.687 277.33 536.722 277.256C536.758 277.184 536.78 277.107 536.788 277.027C536.796 276.947 536.79 276.868 536.77 276.79C536.751 276.711 536.717 276.639 536.671 276.571C536.625 276.504 536.569 276.445 536.502 276.395H536.499L536.45 276.363L536.438 276.354C535.548 275.763 534.57 275.364 533.504 275.156C529.239 274.323 525.064 276.909 524.178 280.935C523.293 284.962 526.035 288.899 530.304 289.734C530.833 289.838 531.367 289.89 531.908 289.89C532.449 289.89 532.984 289.837 533.513 289.733C534.042 289.63 534.555 289.475 535.05 289.272C535.546 289.068 536.014 288.82 536.455 288.525L536.47 288.516L536.502 288.492L536.516 288.484C536.655 288.376 536.744 288.24 536.782 288.074C536.793 288.028 536.798 287.982 536.798 287.935C536.798 287.888 536.794 287.842 536.785 287.796C536.775 287.75 536.761 287.705 536.742 287.662C536.724 287.619 536.701 287.577 536.673 287.538C536.646 287.499 536.615 287.462 536.58 287.429C536.546 287.396 536.508 287.366 536.466 287.34C536.425 287.313 536.382 287.291 536.336 287.273C536.29 287.254 536.243 287.241 536.195 287.231Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_117_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.526 272.602L520.867 289.277L536.272 292.287L539.932 275.612L524.526 272.602Z",
    fill: "url(#paint1_linear_117_407)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 526,
    y: 277,
    width: 10,
    height: 10
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M535.647 277.802H526.971V286.901H535.647V277.802Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_117_407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 527,
    y: 277,
    width: 9,
    height: 10
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M533.134 286.693C532.739 286.797 532.336 286.852 531.927 286.858C531.517 286.863 531.113 286.819 530.715 286.726L530.547 286.682H530.544C530.456 286.658 530.369 286.632 530.283 286.603C530.197 286.575 530.112 286.544 530.027 286.511C529.943 286.478 529.859 286.442 529.777 286.405C529.695 286.367 529.614 286.327 529.534 286.285C529.454 286.243 529.376 286.198 529.299 286.152C529.221 286.106 529.146 286.058 529.071 286.007C528.997 285.957 528.925 285.904 528.854 285.85C528.783 285.796 528.713 285.74 528.646 285.681C528.578 285.623 528.513 285.564 528.449 285.502C528.385 285.44 528.323 285.377 528.263 285.311C528.203 285.246 528.145 285.18 528.089 285.112C528.033 285.044 527.979 284.974 527.927 284.903C527.875 284.832 527.826 284.759 527.778 284.686C527.731 284.612 527.686 284.537 527.643 284.461C527.601 284.384 527.56 284.307 527.522 284.228C527.484 284.15 527.448 284.071 527.415 283.99C527.382 283.91 527.351 283.829 527.323 283.747C527.295 283.665 527.269 283.582 527.245 283.499C527.222 283.415 527.201 283.331 527.183 283.247C527.165 283.162 527.15 283.077 527.137 282.992C527.123 282.906 527.113 282.821 527.106 282.735C527.098 282.649 527.092 282.563 527.09 282.477C527.088 282.39 527.088 282.304 527.091 282.218C527.093 282.132 527.099 282.046 527.107 281.96C527.114 281.874 527.125 281.788 527.138 281.703C527.152 281.618 527.167 281.533 527.185 281.448C527.204 281.363 527.225 281.279 527.248 281.196C527.272 281.113 527.297 281.03 527.326 280.948C527.355 280.866 527.386 280.785 527.419 280.705C527.453 280.625 527.488 280.545 527.527 280.467C527.565 280.389 527.605 280.311 527.648 280.235C527.691 280.159 527.737 280.084 527.785 280.011C527.832 279.937 527.882 279.865 527.933 279.794C527.986 279.722 528.04 279.653 528.096 279.585C528.152 279.517 528.21 279.451 528.271 279.385C528.33 279.321 528.393 279.257 528.457 279.196C528.521 279.134 528.586 279.075 528.654 279.016C528.722 278.959 528.792 278.902 528.863 278.848C528.934 278.794 529.006 278.742 529.08 278.692C529.155 278.642 529.231 278.593 529.308 278.547C529.386 278.501 529.464 278.457 529.544 278.415C529.624 278.373 529.705 278.334 529.787 278.296C529.87 278.258 529.953 278.223 530.038 278.19C530.122 278.157 530.208 278.127 530.294 278.098C530.38 278.07 530.467 278.044 530.555 278.02C530.643 277.996 530.731 277.975 530.821 277.957C530.91 277.938 531 277.922 531.09 277.908C531.18 277.894 531.271 277.882 531.362 277.873C531.452 277.864 531.544 277.857 531.635 277.853C531.726 277.849 531.818 277.847 531.909 277.848C532 277.849 532.092 277.852 532.183 277.858C532.274 277.864 532.365 277.872 532.456 277.883C532.547 277.894 532.637 277.907 532.727 277.923C532.817 277.938 532.906 277.956 532.995 277.977C533.084 277.997 533.172 278.02 533.26 278.045C533.347 278.07 533.434 278.098 533.519 278.128C533.605 278.157 533.69 278.19 533.774 278.224C533.857 278.259 533.94 278.296 534.021 278.335C534.103 278.374 534.183 278.415 534.263 278.459C534.341 278.502 534.419 278.547 534.495 278.595C534.572 278.642 534.646 278.692 534.72 278.743C534.793 278.795 534.865 278.848 534.935 278.904C535.004 278.959 535.073 279.017 535.139 279.076C535.206 279.135 535.27 279.196 535.333 279.259L535.457 279.39C535.474 279.41 535.488 279.431 535.501 279.453C535.549 279.532 535.581 279.617 535.598 279.708C535.613 279.798 535.612 279.888 535.594 279.978C535.575 280.068 535.541 280.153 535.49 280.231C535.44 280.309 535.376 280.377 535.3 280.433C535.224 280.49 535.139 280.532 535.047 280.56C534.954 280.589 534.859 280.601 534.762 280.597C534.665 280.593 534.572 280.573 534.483 280.537C534.393 280.501 534.313 280.452 534.242 280.389L534.167 280.31C534.037 280.18 533.896 280.061 533.744 279.955C533.592 279.848 533.43 279.755 533.26 279.676C533.09 279.597 532.914 279.532 532.732 279.483C532.55 279.434 532.364 279.4 532.176 279.383C531.987 279.365 531.798 279.363 531.609 279.377C531.42 279.392 531.234 279.421 531.05 279.468C530.867 279.514 530.69 279.574 530.518 279.65C530.346 279.726 530.183 279.816 530.028 279.92C529.874 280.023 529.73 280.139 529.598 280.267C529.465 280.395 529.346 280.533 529.24 280.682C529.134 280.83 529.043 280.985 528.966 281.149C528.89 281.313 528.829 281.482 528.785 281.656C528.741 281.83 528.713 282.006 528.703 282.185C528.692 282.363 528.698 282.541 528.722 282.719C528.745 282.897 528.785 283.071 528.842 283.241C528.898 283.412 528.971 283.577 529.059 283.735C529.147 283.894 529.249 284.044 529.365 284.185C529.481 284.326 529.61 284.456 529.751 284.576C529.893 284.695 530.044 284.801 530.206 284.895C530.368 284.988 530.537 285.068 530.714 285.133C530.89 285.197 531.072 285.247 531.258 285.281C531.444 285.315 531.632 285.334 531.821 285.336C532.011 285.338 532.199 285.324 532.386 285.294C532.573 285.265 532.756 285.219 532.934 285.159C533.329 285.026 533.681 284.825 533.99 284.558C533.993 284.558 533.993 284.558 533.993 284.555L534.06 284.498C534.096 284.469 534.134 284.442 534.176 284.419C534.259 284.373 534.348 284.342 534.443 284.325C534.538 284.31 534.633 284.31 534.728 284.326C534.823 284.342 534.912 284.373 534.995 284.42C535.078 284.466 535.15 284.524 535.211 284.595C535.272 284.666 535.318 284.744 535.349 284.83C535.38 284.916 535.394 285.005 535.392 285.096C535.389 285.187 535.37 285.275 535.334 285.359C535.298 285.444 535.248 285.52 535.183 285.587C535.155 285.619 535.124 285.647 535.09 285.672H535.087C534.523 286.161 533.873 286.501 533.134 286.693Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_117_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.145 279.808L533.758 274.529L539.555 284.902L528.942 290.181L523.145 279.808Z",
    fill: "url(#paint2_linear_117_407)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 529,
    y: 280,
    width: 8,
    height: 4
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M536.236 280.972H529.912V283.73H536.236V280.972Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_117_407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_117_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 529,
    y: 281,
    width: 8,
    height: 3
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M529.994 282.169C530.004 282.095 530.022 282.022 530.045 281.951C530.069 281.879 530.099 281.81 530.134 281.743C530.17 281.677 530.212 281.614 530.259 281.553C530.307 281.493 530.359 281.438 530.416 281.386C530.474 281.334 530.535 281.287 530.601 281.245C530.666 281.203 530.735 281.167 530.807 281.136C530.88 281.105 530.954 281.08 531.031 281.061C531.107 281.042 531.185 281.029 531.264 281.022C531.343 281.015 531.422 281.015 531.501 281.021C531.581 281.027 531.658 281.039 531.735 281.057C531.812 281.076 531.887 281.1 531.959 281.13C532.032 281.16 532.101 281.196 532.168 281.237C532.234 281.279 532.296 281.324 532.354 281.376C532.411 281.427 532.464 281.482 532.512 281.542C532.561 281.601 532.603 281.664 532.639 281.73C532.676 281.797 532.707 281.866 532.731 281.937C533.009 282.084 533.391 282.174 533.816 282.174C534.181 282.174 534.517 282.106 534.78 281.994C534.847 281.886 534.938 281.801 535.055 281.74C535.112 281.709 535.173 281.685 535.237 281.67C535.275 281.661 535.314 281.656 535.353 281.653C535.46 281.643 535.565 281.655 535.667 281.688C535.77 281.722 535.859 281.774 535.937 281.844H535.94L535.995 281.901C536.025 281.932 536.05 281.966 536.071 282.002C536.095 282.043 536.115 282.085 536.13 282.128C536.145 282.173 536.156 282.217 536.162 282.264C536.168 282.309 536.17 282.356 536.166 282.401C536.162 282.448 536.154 282.493 536.141 282.538C536.128 282.582 536.111 282.626 536.088 282.667C536.067 282.708 536.041 282.747 536.01 282.784C535.98 282.82 535.946 282.853 535.91 282.884C535.872 282.914 535.832 282.941 535.79 282.963C535.654 283.036 535.508 283.066 535.353 283.051C535.313 283.047 535.275 283.041 535.237 283.032C535.116 283.003 535.011 282.949 534.919 282.871L534.835 282.786C534.835 282.784 534.834 282.783 534.832 282.783L534.78 282.71C534.517 282.595 534.181 282.526 533.816 282.526C533.391 282.526 533.009 282.617 532.731 282.767C532.703 282.844 532.668 282.919 532.626 282.991C532.583 283.062 532.534 283.129 532.479 283.192C532.423 283.255 532.361 283.313 532.295 283.365C532.227 283.417 532.156 283.463 532.08 283.503C532.005 283.543 531.925 283.576 531.843 283.602C531.76 283.628 531.677 283.647 531.59 283.658C531.504 283.669 531.418 283.673 531.331 283.67C531.245 283.666 531.159 283.655 531.074 283.636C530.99 283.618 530.907 283.592 530.828 283.559C530.748 283.527 530.672 283.487 530.601 283.441C530.529 283.395 530.462 283.343 530.4 283.285C530.339 283.228 530.283 283.165 530.234 283.098C530.184 283.031 530.142 282.959 530.106 282.885C530.07 282.81 530.042 282.733 530.022 282.653C530.002 282.573 529.989 282.493 529.984 282.411C529.979 282.329 529.983 282.247 529.994 282.166V282.169Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_117_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.915 279.855L536.729 283.564L530.234 284.833L529.419 281.124L535.915 279.855Z",
    fill: "url(#paint3_linear_117_407)"
  }))))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M485.152 255.383L503.221 308.312H553.415C520.165 296.99 511.315 262.46 509.829 255.383H485.152Z",
    fill: "#ED893E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M703.788 470.27C702.835 470.27 702.021 469.602 701.859 468.693L692.401 415.197L678.795 338.265L674.991 316.752L684.68 316.475L686.363 328.964L698.167 416.727L705.166 468.748C705.275 469.555 704.627 470.27 703.788 470.27Z",
    fill: "#95C0F4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M686.363 328.964C680.084 331.728 678.795 338.265 678.795 338.265L674.991 316.752L684.68 316.475L686.363 328.964Z",
    fill: "#78ACEA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M462.76 470.27C463.711 470.27 464.527 469.602 464.689 468.693L474.147 415.197L487.753 338.265L491.557 316.752L481.866 316.475L480.185 328.964L468.381 416.727L461.382 468.748C461.274 469.555 461.921 470.27 462.76 470.27Z",
    fill: "#95C0F4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M480.185 328.964C486.465 331.728 487.753 338.265 487.753 338.265L491.557 316.752L481.866 316.475L480.185 328.964Z",
    fill: "#78ACEA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M710.254 325.196H462.099C458.849 325.196 456.189 322.544 456.189 319.3V314.202C456.189 310.958 458.849 308.305 462.099 308.305H710.254C713.505 308.305 716.164 310.958 716.164 314.202V319.3C716.164 322.544 713.505 325.196 710.254 325.196Z",
    fill: "#78ACEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_407",
    x1: 537.378,
    y1: 278.802,
    x2: 539.099,
    y2: 279.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#2B6ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#2E66D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#3160D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#3260D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#335ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#355BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#355ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3855CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3953CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3B4FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3C4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3D4CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#453EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#463DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#473CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4E2FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4F2EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#4F2DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#502DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#502CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#512BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#512AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5229AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#5228AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5328AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5327AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5327AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_117_407",
    x1: 527.413,
    y1: 271.702,
    x2: 534.052,
    y2: 292.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0093D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#0095D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0097D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334773,
    stopColor: "#0098D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0098D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#009DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00A0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#00A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#00A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00A5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#00A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00A6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665227,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#00B2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#00B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#00B9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_117_407",
    x1: 526.068,
    y1: 285.512,
    x2: 536.549,
    y2: 279.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405615,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#00B6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#00B6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00B5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#00B5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#00B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#00B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00B3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00B3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00B3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00B1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959438,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_117_407",
    x1: 536.995,
    y1: 284.775,
    x2: 530.532,
    y2: 286.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2770DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2B6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#2D67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2E65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3260D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#345BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3559CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#3856CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3954CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3D4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#3D4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4048C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#4145C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#453EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#463CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#473BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4938B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4A35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2FB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 530,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_117_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(524 275)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroFintech2);
export default __webpack_public_path__ + "static/media/hero-fintech-2.43fc5467bf4e3b9533c831ddaeafb35f.svg";
export { ForwardRef as ReactComponent };